module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wohlenschwil_AG-a3f0c1a139bc68616d50db63ee23cfad.svg";